;var CardsPosition = (function() {

  var content;
  var qtyCards;

  var currentPosition = 0;
  var animation = null;

  function setup( _content ) {
    content = _content;
    qtyCards = content.length;

    $(window).resize(update);
  }

  function incrementPosition( _position, isTween ) {
    if ( isTween ) {
      tween( currentPosition + _position );
    } else {
      set( currentPosition + _position );
    }
  }

  function snapPosition() {
    tween( currentPosition, 150 );
  }

  function goToNextCard() {
    tween( currentPosition + 1 );
  }

  function goToPreviousCard() {
    tween( currentPosition - 1 );
  }

  function goToFirstCard() {
    tween( 0, 750 );
  }

  function setByYear( year ) {
    var newPosition = 0;
    for ( var i = 0; i < content.length; i++ ) {
      if ( content[i].filtered ) {
        if ( content[i].ano >= year ) {
          CardsPosition.set( newPosition );
          return;
        }

        newPosition++;
      }
    }

    //if don't find anyone, go to the last
    CardsPosition.set( 999999 );
  }

  function tween( newPosition, duration ) {
    if ( animation ) {
      animation.pause();
    }

    var objectPosition = {
      position: currentPosition
    }

    animation = anime({
      targets: objectPosition,
      position: Math.round( newPosition ),
      duration: duration === undefined ? 500 : duration,
      easing: 'easeOutExpo',
      update: function() {
        set( Number(objectPosition.position) );
      }
    });
  }

  function set( _position ) {
    currentPosition = _position;

    var qtyFilteredCards = 0;
    for ( var i = 0; i < qtyCards; i++ ) {
      if ( content[i].filtered ) {
        qtyFilteredCards++;
      }
    }
    if ( currentPosition > qtyFilteredCards - 1 ) {
      currentPosition = qtyFilteredCards - 1;
    } else if ( currentPosition <= 0 ) {
      currentPosition = 0;
    }

    update();
  }

  function update() {
    var z = qtyCards;
    var maxVisibleCards = 12;
    var difference = 0;
    var prevYear;
    var nextYear;
    var minMarkerPosition = Ruler.minPosition();
    var maxMarkerPosition = Ruler.maxPosition();
    var minYear = 1500;
    var maxYear = 2016;
    var mobileWidth = 1000;

    if (window.innerWidth <= mobileWidth) {
      maxVisibleCards = Map( window.innerWidth, 320, mobileWidth, 4, 12 );
      maxVisibleCards = Math.ceil(maxVisibleCards);
    }

    $( '.cards .card' ).removeClass( 'show-biography' );

    for ( var i = 0; i < qtyCards; i++ ) {
      if ( !content[i].filtered ) {
        difference++;
      }

      var position = i - currentPosition - difference;

      if ( position <= -1 || position > maxVisibleCards || !content[i].filtered ) {
        if ( content[i].show ) {
          content[i].dom.detach();
          content[i].show = false;
        } 
      } else {
        var magicNumber = 208;
        if (window.innerWidth <= mobileWidth) {
          magicNumber = Map( window.innerWidth, 320, mobileWidth, 80, 200 );
        }
        var translateX = magicNumber * position * ( Math.log( 2.5 ) / Math.log( position + 4.5 ) );
        var scale = 1 - ( 0.05 * position );

        content[i].dom.css({
          'transform': 'translate(' + translateX + 'px, -50%) scale(' + scale + ')',
          'z-index': z
        }).attr('position', position);

        if ( position < 0 ) {
          content[i].dom.css( 'opacity', Map( position, -1, 0, 0, 1 ) );
          //content[i].dom.find( '.opacity' ).css( 'opacity', 0 )
          prevYear = content[i].ano;
        } else if ( position < 1 ) {
          //need to be 0, so can't show a resized card
          //as we always snap to position, there's no problem with it
          if (position == 0) {
            content[i].dom.addClass( 'show-biography' );
          }
          content[i].dom.css( 'opacity', 1 );
          content[i].dom.find( '.opacity' ).css( 'opacity', Map( position, 0, 1, 0, 0.5 ) );

          nextYear = content[i].ano;
        } else if ( position < maxVisibleCards - 1 ) {
          content[i].dom.css( 'opacity', 1 );
          content[i].dom.find( '.opacity' ).css( 'opacity', Map( position, 0, maxVisibleCards, 0.5, 0.9 ) );
        } else {
          content[i].dom.css( 'opacity', Map( position, maxVisibleCards-1, maxVisibleCards, 1, 0 ) );
          content[i].dom.find( '.opacity' ).css( 'opacity', Map( position, 0, maxVisibleCards, 0.5, 0.9 ) );
        }

        if ( !content[i].show ) {
          $( '.container .cards' ).append( content[i].dom );
          content[i].show = true;
        }

        z--;
      }
    }

    if (!nextYear) {
      nextYear = maxYear;
    }
    if (!prevYear) {
      prevYear = nextYear;
    }

    var yearPercent = currentPosition % 1;
    var currentYear = Map(yearPercent, 0, 1, prevYear, nextYear);
    var translateMarker = Map( currentYear, minYear, maxYear, minMarkerPosition, maxMarkerPosition );

    $( '.ruler .marker' ).css( 'left', translateMarker + 'px' );
    $( '.ruler .ghost-marker' ).css( 'left', translateMarker + 'px' );
    $( '.ruler .marker .ano' ).text( parseInt( currentYear ) );
  }

  return {
    setup: setup,
    incrementPosition: incrementPosition,
    snapPosition: snapPosition,
    goToNextCard: goToNextCard,
    goToPreviousCard: goToPreviousCard,
    goToFirstCard: goToFirstCard,
    setByYear: setByYear,
    set: set,
  }

})();
